<template>
    <div>
        <Setting></Setting>
        <Game></Game>
    </div>
</template>

<script>
    import Setting from "./components/Setting";
    import Game from "./components/Game";

    export default {
        components: {Setting, Game}
    };
</script>

<style scoped>

</style>
